export default __webpack_public_path__ + "static/media/soy-bean.805004aa.svg";